import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await login(username.trim(), password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Sveiki sugrįžę");
      navigate("/admin");
    } else {
      setError(res.error || "Nepavyko prisijungti");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="w-full max-w-md border border-[#e5e2dd] bg-white p-10"
      >
        <div className="text-center">
          <div className="font-serif-display italic text-[#a66e4b] text-3xl">
            MANOPIRTIS.LT
          </div>
          <div className="overline text-[#7a7570] mt-2">administravimas</div>
        </div>

        <div className="mt-10 space-y-6">
          <div>
            <label className="overline text-[#5c5c5c] block mb-3">Vartotojo vardas</label>
            <input
              data-testid="admin-input-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              className="w-full bg-transparent border-b border-[#d8d4ce] focus:border-[#a66e4b] outline-none py-3 text-[#1a1a1a] font-light"
            />
          </div>
          <div>
            <label className="overline text-[#5c5c5c] block mb-3">Slaptažodis</label>
            <input
              data-testid="admin-input-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full bg-transparent border-b border-[#d8d4ce] focus:border-[#a66e4b] outline-none py-3 text-[#1a1a1a] font-light"
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-sm text-[#e57373] font-light">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full py-4 bg-[#a66e4b] text-[#0f0f0f] uppercase tracking-[0.26em] text-[12px] font-medium hover:bg-[#bd825c] transition disabled:opacity-50"
          >
            {submitting ? "Jungiama…" : "Prisijungti"}
          </button>
        </div>
      </form>
    </div>
  );
}
